import { JsonObject, JsonProperty } from 'json2typescript';
import { Moment } from 'moment';

import { DateAdapter } from '../../client/helpers/serializer/adapters/date.adapter';
import { PBCPenaltyInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('PBCPenalty')
export class PBCPenalty implements PBCPenaltyInterface {
    @JsonProperty('nombre', StringAdapter, true)
    private _name?: string = undefined;

    @JsonProperty('fechaInicio', DateAdapter)
    private _startAt: Moment = undefined;

    @JsonProperty('fechaFin', DateAdapter)
    private _endAt: Moment = undefined;

    get name(): string {
        return this._name;
    }

    get startAt(): moment.Moment {
        return this._startAt;
    }

    get endAt(): moment.Moment {
        return this._endAt;
    }
}
